<template>
  <VBlock class="banner-wrapper" :onClick="openWebview">
    <div :style="backgroundImage" class="bannerImage" />
  </VBlock>
</template>

<script>
import VBlock from '@/presentationals/v2/components/layouts/molecules/VBlock'
import BannerImage from '@/assets/images/banner/orderHistoryBanner_1.png'

export default {
  name: 'OrderHistoryBanner',
  components: {
    VBlock
  },
  props: {
    openWebview: {
      type: Function
    }
  },
  computed: {
    backgroundImage() {
      return {
        backgroundImage: `url('${BannerImage}')`
      }
    }
  },
  data() {
    return {
      resources: {
        BannerImage
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.banner-wrapper {
  width: 100vw;
  height: 64px;
  box-sizing: border-box;

  .bannerImage {
    width: 100%;
    height: 100%;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
  }
}
</style>
